export const getOrdinalSuffix = ({ number }: { number: number }) => {
  const suffix = ["th", "st", "nd", "rd"];
  const last_two_digits = number % 100;
  return (
    number +
    (suffix[(last_two_digits - 20) % 10] ||
      suffix[last_two_digits] ||
      suffix[0])
  );
};
